(function($) {

    var propCallback = $.fn.prop;
    var attrCallback = $.fn.attr;
    var htmlCallback = $.fn.html;
    var select2Callback = $.fn.select2;
    var summernoteCallback = $.fn.summernote;
    var fileuploadCallback = $.fn.fileupload;

    $.fn.prop = function(name, value) {
        if (name == "disabled" && value == false) {
            var permitirhabilitar = this.attr("permitirhabilitar");
            if (permitirhabilitar != undefined && permitirhabilitar == "false") {
                return this.attr(name);
            }
        }
        return propCallback.apply(this, arguments);
    };

    $.fn.attr = function(name, value) {
        if (name == "disabled" && value == false) {
            var permitirhabilitar = this.attr("permitirhabilitar");
            if (permitirhabilitar != undefined && permitirhabilitar == "false") {
                return this.attr(name);
            }
        }
        return attrCallback.apply(this, arguments);
    };

    var desabilitarElementos = function() {
        var $this = $(this);
        var permitirhabilitar = $this.attr("permitirhabilitar");
        if (permitirhabilitar != undefined && permitirhabilitar == "false") {
            $this.prop("disabled", true);
            $(".note-editable", $this).attr("contenteditable", false);
            $(".fileinput-button", $this.parent()).remove();
        }
    };

    $.fn.html = function() {
        var result = htmlCallback.apply(this, arguments);
        $("[permitirhabilitar]", this).each(desabilitarElementos);
        return result;
    };

    $.fn.select2 = function() {
        var result = select2Callback.apply(this, arguments);
        this.each(desabilitarElementos);
        return result;
    };

    $.fn.summernote = function() {
        var result = summernoteCallback.apply(this, arguments);
        var permitirhabilitar = this.attr("permitirhabilitar");
        if (permitirhabilitar != undefined && permitirhabilitar == "false") {
            $(".note-editable", this.parent()).attr("contenteditable", false);
        }
        var desabilitarBottoes = this.attr("desabilitarBottoes");
        if (desabilitarBottoes == "true") {
            $('.note-toolbar').remove();
        }
        return result;
    };

    $.fn.fileupload = function() {
        var result = fileuploadCallback.apply(this, arguments);
        var permitirhabilitar = this.attr("permitirhabilitar");
        if (permitirhabilitar != undefined && permitirhabilitar == "false") {
            $(".fileinput-button", this).remove();
        }
        return result;
    };

    $(document)
        .ready(function() {
            $("[permitirhabilitar]")
                .each(desabilitarElementos);
        });

})(jQuery);